import React from 'react'
import { ApolloProvider } from '@apollo/react-hooks'
import ApolloClient from 'apollo-boost'
import fetch from 'isomorphic-fetch'

export const client = new ApolloClient({
  uri: process.env.GATSBY_AWS_APPSYNC_API_URL,
  headers: {
    'x-api-key': process.env.GATSBY_AWS_APPSYNC_API_KEY,
  },
  fetch,
})

const ApolloWrapper = ({ children }) => (
  <ApolloProvider client={client}>{children}</ApolloProvider>
)

export default ApolloWrapper
